import {useSettings} from '@common/core/settings/use-settings';
import {useAuth} from '@common/auth/use-auth';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate,
} from 'react-router-dom';
import {ToastContainer} from '@common/ui/toast/toast-container';

import React, {Fragment, useEffect} from 'react';
import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {DialogStoreOutlet} from '@common/ui/overlays/store/dialog-store-outlet';
import {AdminAuthRoute} from '@common/auth/guards/admin-auth-route';
import {UserAuthRoute} from '@common/auth/guards/user-auth-route';
import {Role} from '@common/auth/user';
import {LoginPage} from '@common/auth/ui/login-page';
import {GuestRoute} from '@common/auth/guards/guest-route';

const AdminRoutes = React.lazy(() => import('@common/admin/admin-routes'));

const SiteRoutes = React.lazy(() => import('@app/site-routes'));

export function AppRoutes() {
    const {user} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!user) return;
        if (user && !location.pathname?.includes('/admin')) {
            navigate('/admin');
        }

        return () => {};
    }, [user, location]);

    if (!user) {
        return (
            <Fragment>
                <ToastContainer />
                <Routes>
                    <Route
                        path="*"
                        element={
                            <GuestRoute>
                                <LoginPage />
                            </GuestRoute>
                        }
                    />
                </Routes>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <ToastContainer />
            <Routes>
                {/* {user?.role == Role.ADMIN && (
                    <Route
                        path="/*"
                        element={
                            <UserAuthRoute requireLogin={true}>
                                <React.Suspense
                                    fallback={<FullPageLoader screen />}
                                >
                                    <SiteRoutes />
                                </React.Suspense>
                            </UserAuthRoute>
                        }
                    />
                )} */}

                <Route
                    path="/admin/*"
                    element={
                        <AdminAuthRoute>
                            <React.Suspense
                                fallback={<FullPageLoader screen />}
                            >
                                <AdminRoutes />
                            </React.Suspense>
                        </AdminAuthRoute>
                    }
                />

                <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <DialogStoreOutlet />
        </Fragment>
    );
}
